import Footer from "./Footer";

// Legal pages reuse the main footer in its minimal variant (brand + copyright + legal + lang).
const PrivacyFooter = () => <Footer minimal />;

export default PrivacyFooter;
